module.exports = __webpack_public_path__ + "static/img/COC2023-36.58ac95b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-36.png
// module id = B98S
// module chunks = 0